import classNames from 'classnames'
import { motion } from 'framer-motion'

import useAnimationSheetViewModel from '@/components/detail/components/shared/animationSheet/viewModel'

import type { MotionValue } from 'framer-motion'

import { SHEET_STATE_TYPE } from '@/enums/detail'

interface AnimationSheetProps {
  children: React.ReactNode
  sheetType: SHEET_STATE_TYPE
  sheetPositionY: MotionValue<number>
}

export const AnimationSheet = ({ children, sheetType, sheetPositionY }: AnimationSheetProps) => {
  const { texts, states, handlers } = useAnimationSheetViewModel({ sheetType })
  const { customClass } = texts
  const { scrollContainerRef } = states
  const { controls, handleDragEnd, toVariant } = handlers

  return (
    <motion.div
      id={'layer2'}
      className={classNames(`${customClass}`)}
      initial={toVariant(sheetType)}
      animate={controls}
      transition={{
        type: 'spring',
        damping: 40,
        stiffness: 400
      }}
      variants={{
        close: {
          y: 250,
          height: '250px'
        },
        hidden: {
          y: 'calc(100% - 250px)',
          height: '250px'
        },
        visible: {
          y: 0,
          height: '100%'
        }
      }}
      drag="y"
      dragConstraints={{
        top: 0,
        bottom: 0
      }}
      style={{ y: sheetPositionY }}
      dragElastic={0}
      dragMomentum={false}
      onDragEnd={handleDragEnd}
    >
      <div
        id="modu-scroll"
        ref={scrollContainerRef}
        className={classNames(
          `relative h-full w-full overscroll-none ${toVariant(sheetType) === 'visible' ? 'overflow-y-scroll' : ''}`
        )}
      >
        {children}
      </div>
    </motion.div>
  )
}
